import React, { useEffect } from 'react';
import { TouchableOpacity, View } from 'react-native';
import {
  Button,
  DefaultScreenContainer,
  InsuranceCardBenefit,
  OfferBanner,
  Text,
} from '~/components';
import useAppNavigation from '~/hooks/useAppNavigation';
import { isWeb } from '~/utils/device';

import MoneyBillSVG from '~/assets/svgs/money-bill.svg';
import ProtectionShiledSVG from '~/assets/svgs/protection-shield.svg';
import LucklyCloverSVG from '~/assets/svgs/luckly-clover.svg';

import BannerImg from '~/assets/img/banners/bag-protection-banner.png';
import BannerImgDesk from '~/assets/img/banners/bag-protection-banner-desk.png';
import type { Benefit } from '~/components/InsuranceCardBenefit';
import { journeyLogUseCase } from '~/useCases/PSF/JourneyLogUseCase';
import { useUserInfoStore } from '~/stores/userInfo';
import GeneralInfoFooter from '../components/GeneralInfoFooter';
import { useSalesFunnel } from '~/stores';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

const INSURANCE_TYPE = 'bag-protection';

const BENEFITS: Benefit[] = [
  {
    icon: ProtectionShiledSVG,
    title: 'Fique protegida',
    description: (
      <Text className="text-sm mt-0">
        Indenização de até{' '}
        <Text className="text-primary-600 font-medium">R$ 2.000,00</Text> em
        transações indevidas realizadas com seu Cartão de crédito. Efetuadas em
        até 96 horas do acionamento do seguro.
      </Text>
    ),
  },
  {
    icon: MoneyBillSVG,
    title: 'Indenização de seus pertences',
    description: (
      <Text className="text-sm">
        Bolsa, carteira, telefone celular, óculos de sol ou de grau, cosméticos,
        perfume e chaves, limitado ao valor total de até{' '}
        <Text className="text-primary-600 font-medium">R$ 2.000,00</Text>
      </Text>
    ),
  },
  {
    icon: LucklyCloverSVG,
    title: 'Concorra a prêmios',
    description: (
      <Text className="text-sm">
        Você concorre toda semana à{' '}
        <Text className="text-primary-600 font-medium">R$ 1.500,00</Text> pela
        loteria federal. Valor líquido de IR.
      </Text>
    ),
  },
];

const BagProtectionDetails: React.FC = () => {
  const { setOptions, goBack } = useAppNavigation();
  const { init } = useSalesFunnel();

  const id = useUserInfoStore((state) => state.user?.id);

  useEffect(() => {
    setOptions({
      // headerTitle: () => <Logo onPress={() => setModalVisible(true)} />,
    });
  }, [setOptions]);

  useEffect(() => {
    init('bag-protection');
    if (id) {
      journeyLogUseCase(useUserInfoStore.getState().user, 'PROTECAOBOLSA');
    }
  }, [id, init]);

  return (
    <DefaultScreenContainer>
      <OfferBanner
        hireInsurance={{
          showButton: true,
          type: INSURANCE_TYPE,
          label: 'Contrate em nossas lojas',
          onPressButton: MarisaAppUtils.goToStoresList,
        }}
        images={{
          mobile: BannerImg,
          web: { banner: BannerImgDesk },
        }}
        insuranceName="Proteção Bolsa"
        insuranceDetail="Proteja seu celular e seus pertences"
      />

      <View className="px-6">
        <View className="md:items-center md:justify-center items-start justify-start">
          <Text className="mt-6 sm:mt-16 text-gray-700 text-[22px]">
            O que é o Proteção Bolsa?
          </Text>

          <Text className="mt-4 text-gray-400 md:text-center text-[16px] leading-6">
            Garanta proteção dos seus itens em casos de roubo ou furto
            qualificado.
          </Text>

          <View className="h-[1px] bg-gray-100 w-full my-10 mb-2 hidden md:flex" />
        </View>

        <View className="bg-protection-200 p-3 rounded-[16px] mb-3 mt-8">
          <View className="bg-light-100 py-6 px-3 rounded-lg border border-primary-600 items-center justify-center">
            <Text className="font-medium text-base text-primary-600 text-center">
              E ainda concorra a sorteios semanais!
            </Text>
          </View>
        </View>

        <Text className="text-xl text-gray-700 md:items-center md:justify-center md:text-center md:mb-6">
          Conheça os benefícios:
        </Text>

        <View className="lg:flex-row lg:justify-between">
          {BENEFITS.map((benefit, index) => (
            <InsuranceCardBenefit
              data={benefit}
              type="protection"
              key={index}
            />
          ))}
        </View>

        <View className="items-center justify-center py-8 bg-feedback-neutral-bkg rounded-lg mb-7 my-8">
          <Text className="text-secondary-800 text-sm">
            Tudo isso por apenas R${' '}
            <Text className="text-xl font-medium">10,99</Text>
            /mês
          </Text>
        </View>
      </View>

      <Text className="text-center text-xs text-gray-400 px-2">
        Forma de pagamento: Pix, Dinheiro, Débito, Cartão Marisa ou no Cartão de
        Crédito de sua preferência.
      </Text>

      <View className="px-6 py-4  justify-center  mt-8">
        <Button onPress={MarisaAppUtils.goToStoresList}>
          Contrate em nossas lojas
        </Button>
      </View>
      <View className="px-6 lg:w-[70%] items-center justify-center mx-auto">
        <GeneralInfoFooter className="mb-4 mt-4" />
      </View>
      <View className="py-4 px-6 items-center justify-center lg:mx-auto lg:w-[328px]">
        {isWeb && (
          <TouchableOpacity onPress={() => goBack()}>
            <Text className="text-primary-600 uppercase font-medium mt-4 text-xs">
              Voltar
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </DefaultScreenContainer>
  );
};

export default BagProtectionDetails;
